import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  slackUsers: null,
}

const slackModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
export default slackModule
